import React from 'react';
import {ProvideConstancia} from "./State/ProvideConstancia";
import VistaConstancia from "./VistaConstancia";


const Constancia = () => {

    return (
        <ProvideConstancia >
            <VistaConstancia/>
        </ProvideConstancia>
    );
};

export default Constancia;